export default __webpack_public_path__ + "8e579484d381cd8a9a8957095022263f.png";